import styled from 'styled-components';

export const StyledBadgeCount = styled.span`
   position: absolute;
   top: -5px;
   right: -5px;
   display: flex;
   align-items: center;
   justify-content: center;
   width: 16px;
   height: 16px;
   padding: 0;
   border-radius: 50%;
   background: ${(props) => props.theme.error};
   color: ${(props) => props.theme.white};
   font-size: 10px;
   line-height: 1;
   font-weight: 500;
   box-sizing: border-box;
   pointer-events: none;
`;
StyledBadgeCount.displayName = 'StyledBadgeCount';
